/**
 * Version Control Configuration
 *
 * NOTE: v9 and v9.5 were removed in fe-improvement-settings. v11 is the only
 * supported version. This module is kept (instead of inlined) because
 * `versionConfig.getDefaultRoute()` is still referenced by the global route
 * fallback in App.tsx. If a future version is introduced, extend here.
 */

export type AppVersion = 'v11';

// Version-specific default routes
const VERSION_ROUTES: Record<AppVersion, string> = {
  v11: '/v11/feed',
};

const DEFAULT_VERSION: AppVersion = 'v11';

// Export configuration object
export const versionConfig = {
  defaultVersion: DEFAULT_VERSION,
  allowedVersions: ['v11'] as AppVersion[],

  isVersionAllowed(version: AppVersion): boolean {
    return this.allowedVersions.includes(version);
  },

  getDefaultRoute(): string {
    return VERSION_ROUTES[this.defaultVersion];
  },
};
